import { Fragment } from "react";
import {
  SCC_INTEGRATED_TEST_BANNER_END_DATE,
  SCC_INTEGRATED_TEST_BANNER_TEXT,
} from "../../../constants/sccClinicalInfoConfig";

interface SccIntegratedTestBannerProps {
  values: { testTypeId?: number | string };
  setFieldValue: unknown;
}

function SccIntegratedTestBanner({
  values,
}: Readonly<SccIntegratedTestBannerProps>): JSX.Element {
  const isScc = Number(values.testTypeId) === 2;
  const withinCampaign = new Date() <= SCC_INTEGRATED_TEST_BANNER_END_DATE;

  if (!isScc || !withinCampaign) {
    return <Fragment />;
  }

  return (
    <div className="py-3 px-3 mt-2 flex items-center bg-teal-50 border-teal-500 border rounded-md">
      <p className="font-sans text-teal-600 text-xs md:text-base">
        {SCC_INTEGRATED_TEST_BANNER_TEXT}
      </p>
    </div>
  );
}

export default SccIntegratedTestBanner;
